export class GradeType {
    readonly gradeGD: string = 'GD';
    readonly gradeI: string = 'I';
    readonly gradeW: string = 'W';

    static getInstance(): GradeType {
        return new GradeType();
    }
}
